// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogPostHero_wrapper__rKo23","gradient":"BlogPostHero_gradient__n__cv"};